import { ArrowIcon } from "assets";
import styles from "./styles.module.scss";

interface MiniCardData {
  users: number | string;
  percentage?: boolean;
  header: string;
  ratingType: string;
  timeFrame?: string;
}

interface CardProps extends MiniCardData {
  openChart: () => void;
  className?: string;
  filter: (name: string) => void;
}

const MiniCard: React.FC<CardProps> = ({
  ratingType,
  users,
  percentage,
  header,
  className,
  timeFrame,
  filter,
}) => {
  return (
    <div className={`${className} ${styles.users}`} onClick={()=>{filter(header)}}>
      <div className={styles.usersHead}>
        <p className={styles.head}>{header}</p>
      </div>
      <p className={styles.number}>{users}{percentage && `%`}</p>
      <div className={styles.rate}>
        <div className={styles[ratingType?.toLowerCase()]}>
          <ArrowIcon className={styles[ratingType?.toLowerCase()+'Arrow']}/>
          <p className={styles[ratingType?.toLowerCase()+'Desc']}>{ratingType}</p>
        </div>
        <p className={styles.monthly}>{timeFrame}</p>
      </div>
    </div>
  );
};

export { MiniCard };
